export const listStockItemsQuery = `
  query ListStockItems($input: ListStockItemsInput) {
    listStockItems(input: $input) {
      code
      stockItems {
        id
        name
        description
        sku
        baseUnit
        quantityOnHand
      }
    }
  }
`;

export const createStockItemQuery = `
  mutation CreateStockItem($input: CreateStockItemInput!) {
    createStockItem(input: $input) {
      code
      id
    }
  }
`;

export const postStockMovementQuery = `
  mutation PostStockMovement($input: PostStockMovementInput!) {
    postStockMovement(input: $input) {
      code
      quantityOnHand
    }
  }
`;

export const stockLedgerQuery = `
  query StockLedger($input: StockLedgerInput!) {
    stockLedger(input: $input) {
      code
      movements {
        id
        movementType
        quantity
        notes
        createdAt
      }
    }
  }
`;
